import {
  DEFAULT_API_RESPONSE,
  DEFAULT_PAGER,
  FilterType,
  TDataTablePager,
} from '@monetize/types/common';
import { useMemo, useState } from 'react';
import { useGetAccountDocumentsByAccount } from '../../api/accountsService';
import {
  buildFilterParamsRequestObject,
  transformTableFilterValue,
} from '../../utils';

export const useAccountDocuments = ({ accountId }: { accountId: string }) => {
  const [filters, setFilters] = useState<FilterType[]>([]);
  const [pager, setPager] = useState<TDataTablePager>(DEFAULT_PAGER);

  const filterParams = useMemo(
    () =>
      buildFilterParamsRequestObject(
        transformTableFilterValue(filters, ['signedAt', 'sentAt']),
      ),
    [filters],
  );

  const {
    isLoading,
    isFetched,
    isRefetching,
    data: accountDocuments,
    refetch,
    isError,
    error,
  } = useGetAccountDocumentsByAccount(
    {
      accountId,
      config: pager,
      filters: filterParams,
    },
    {
      placeholderData: (previousData, previousQuery) => previousData,
      meta: { showErrorToast: true },
    },
  );

  const onResetFilter = () => {
    setFilters([]);
    setPager(DEFAULT_PAGER);
  };

  return {
    pager,
    setPager,
    filters,
    setFilters,
    onResetFilter,
    refetch,
    totalRecords: accountDocuments?.totalElements || 0,
    loading: isLoading || (isRefetching && !isFetched),
    listData: accountDocuments || DEFAULT_API_RESPONSE,
    isError,
    error,
  };
};
